import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { StepNavigationStyled } from '@components/v2/StepNavigation/StepNavigationStyled';
import { rem } from 'polished';

export const StepNavigationStyledOV = styled(StepNavigationStyled)`
    background: ${({ theme }) => theme.colors.grey6};

    .opened,
    .closed {
        border-top: 1px solid ${({ theme }) => theme.colors.grey22};

        .contactUsContainer {
            font-weight: bold;
            color: ${({ theme }) => theme.colors.black};

            .contactUsTitle svg path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }

        .wrapper {
            @media (min-width: ${breakpoints.lg}px) {
                background: white;
            }

            .blurryHolder {
                @media (min-width: ${breakpoints.lg}px) {
                    .icon-wrapper {
                        &:after {
                            width: 19px;
                            height: 19px;
                            display: flex;
                            content: ${({ theme }) => `url('data:image/svg+xml;utf8,
                                <svg aria-hidden="true" width="19px" height="19px" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.15203 18.3188L1.72319 18.8789L10.5765 9.85176L1.48033 0.914551L0.919647 1.4852L9.44565 9.86224L1.15203 18.3188Z" fill="${encodeURIComponent(
                                      theme.colors.black
                                  )}" stroke="${encodeURIComponent(theme.colors.black)}" stroke-width="1.2"></path>
                                </svg>')`};
                        }

                        svg {
                            display: none;
                        }
                    }
                }
            }
            .container {
                .nav-item {
                    border-bottom-color: white;
                    .icon {
                        border-color: ${({ theme }) => theme.colors.grey7};
                        background: ${({ theme }) => theme.colors.grey7};

                        &.selected {
                            border-color: ${({ theme }) => theme.colors.primaryHover};
                            background: ${({ theme }) => theme.colors.white};
                        }
                    }

                    &:hover,
                    &:focus-visible {
                        font-weight: ${({ theme }) => theme.fontWeights.textBold};
                        color: ${({ theme }) => theme.colors.primaryHover};
                        border-color: ${({ theme }) => theme.colors.primaryHover};
                    }

                    svg {
                        g {
                            fill: ${({ theme }) => theme.colors.primaryHover} !important;
                        }
                    }

                    .title {
                        font-size: ${({ theme }) => theme.fontSizes.textMedium};
                    }
                }
            }
        }
    }
`;
